import React, { useState, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import Main from "../../components/Main";
import TabelaDinamica from "../../components/TabelaDinamica";
import MensagemSucesso from "../../components/MensagemSucesso";
import MensagemErro from "../../components/MensagemErro";
import MensagemAviso from "../../components/MensagemAviso";
import styles from "./styles.module.css";
import TextSnippetIcon from "@mui/icons-material/TextSnippet";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import { CurrencyExchange } from "@mui/icons-material";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import {
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Paper,
  IconButton,
  FormControlLabel,
  DialogContentText,
  TextField,
  MenuItem,
  Switch,
  Typography,
} from "@mui/material";
import CircleLoader from "react-spinners/CircleLoader";

import Draggable from "react-draggable";
import { idEmpresaFromComboIds } from "../../utils/idEmpresa";
import CRUDPageHeader from "../../components/CRUDPageHeader";
import {
  enfileirarImportacaoExtrato,
  resolverMensagemErroEnfileiramentoImportacao,
} from "../../services/api-integracao-openai.service";
import {
  atualizarConciliacoes,
  buscarConciliacoes,
  buscarContasBancarias,
  buscarExtrato,
  buscarExtratoPorTexto,
  buscarTransacoes,
  excluirExtrato,
  exportarConciliacoesDominio,
  exportarConciliacoesProtheus,
  filtrarConciliacoesPorData,
  restaurarConciliacoes,
} from "../../services/api-conciliacao.service";
import TabelaConciliacaoExtrato from "./TabelaConciliacaoExtrato";
import RodapeConciliacaoExtrato from "./RodapeConciliacaoExtrato";
import { exportacaoSaldoLiberada } from "./capaSaldo.util";
import GenericDatePicker from "../../components/GenericDatePicker";
import {
  applyQuantiaBuscaMask,
  formatToBRL,
} from "../../utils/currency.util";
import {
  formatarDataExibicaoBr,
  formatarDataIsoLocal,
} from "../../utils/dataFiltro.util";
import {
  aplicarRespostaConciliacoes,
  defaultFiltrosConciliacao,
  deveBloquearPorIntervaloInvalido,
  filtrosConciliacaoLimpos,
  montarBodyIntervaloExportacao,
  montarParamsBuscarConciliacoes,
} from "../../utils/filtrosConciliacao.util";
import { ProtheusDominioStyledSwitch } from "../../components/ProtheusDominioStyledSwitch";
import DeleteIcon from "@mui/icons-material/DeleteForever";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import CloseIcon from "@mui/icons-material/Close";
import SendIcon from "@mui/icons-material/Send";
import bancos from "../../utils/banks.json";

const MSG_ERRO_PADRAO =
  "Não foi possível concluir a operação. Tente novamente em instantes.";

function PaperComponent(props) {
  return (
    <Draggable
      handle="#draggable-dialog-title"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} />
    </Draggable>
  );
}

function arredondar2(n) {
  return Math.round(Number(n) * 100) / 100;
}

/** Ajuste local da capa ao marcar/desmarcar Ignorar (sem refetch). */
function ajustarCapaSaldoPorIgnorado(capa, quantia, passouAIgnorado) {
  if (!capa || capa.saldoAnterior == null) return capa;
  const delta = passouAIgnorado ? -Number(quantia) : Number(quantia);
  if (!Number.isFinite(delta)) return capa;
  const variacaoLiquida = arredondar2(capa.variacaoLiquida + delta);
  const saldoConciliado = arredondar2(capa.saldoAnterior + variacaoLiquida);
  const diferenca =
    capa.saldoAtual != null
      ? arredondar2(saldoConciliado - capa.saldoAtual)
      : null;
  return {
    ...capa,
    variacaoLiquida,
    saldoConciliado,
    diferenca,
    qtdLinhas: Math.max(
      0,
      (capa.qtdLinhas ?? 0) + (passouAIgnorado ? -1 : 1)
    ),
  };
}

const Extrato = () => {
  const location = useLocation();
  const [empresaInicial, setEmpresaInicial] = useState(null);
  const [data, setData] = useState([]);
  const [editRowData, setEditRowData] = useState({});
  const [dadosTransacoes, setDadosTransacoes] = useState([]);
  const [dadosConciliacoes, setDadosConciliacoes] = useState([]);
  const [paginacaoConciliacoes, setPaginacaoConciliacoes] = useState({
    pagina: 0,
    tamanhoPagina: 10,
    totalItens: 0,
    totalPaginas: 0,
  });
  const [msg, setMsg] = useState("");
  const [openSnackbarSucesso, setOpenSnackbarSucesso] = useState(false);
  const [openSnackbarErro, setOpenSnackbarErro] = useState(false);
  const [openSnackbarAviso, setOpenSnackbarAviso] = useState(false);
  const [msgAviso, setMsgAviso] = useState("");
  const [openTransacaoModal, setOpenTransacaoModal] = useState(false);
  const [openConciliacaoModal, setOpenConciliacaoModal] = useState(false);
  const [openFiltrarDataModal, setOpenFiltrarDataModal] = useState(false);
  const [idEmpresa, setIdEmpresa] = useState();
  const [idExtrato, setIdExtrato] = useState();
  const [extratoConciliacao, setExtratoConciliacao] = useState(null);
  const [capaSaldoConciliacao, setCapaSaldoConciliacao] = useState(null);
  const [loading, setLoading] = useState(false);
  const [loadingAcaoConciliacao, setLoadingAcaoConciliacao] = useState(null);
  const [tipoContabilConciliacao, setTipoContabilConciliacao] =
    useState("dominio");
  const [intervalo, setIntervalo] = useState({ intervalo: {} });
  const [filtrosListagem, setFiltrosListagem] = useState(defaultFiltrosConciliacao);
  const [filtrosModal, setFiltrosModal] = useState(defaultFiltrosConciliacao);
  const [quantiaInputFocused, setQuantiaInputFocused] = useState(false);
  const inputFileRef = useRef(null);
  const [openDeleteExtratoModal, setOpenDeleteExtratoModal] = useState(false);
  const [cnpj, setCnpj] = useState("");
  const [row, setRow] = useState(null);
  const [openBankDialog, setOpenBankDialog] = useState(false);
  const [banks, setBanks] = useState([{ value: "", label: "" }]);
  const [bankSelected, setBankSelected] = useState("");
  const [extrato, setExtrato] = useState({});

  const conciliacaoOcupada =
    loading || loadingAcaoConciliacao !== null;

  const renderModalLoader = (visivel) =>
    visivel ? (
      <Box
        className={styles.modalLoadingOverlay}
        aria-busy="true"
        aria-label="Carregando"
      >
        <CircleLoader
          color="#18316e"
          loading
          size={100}
          aria-label="Loading Spinner"
          data-testid="loader"
        />
      </Box>
    ) : null;

  const columns = [
    { id: "idConciliacaoExtrato", label: "ID", field: "idConciliacaoExtrato" },
    { id: "codigoBanco", label: "Banco", field: "codigoBanco" },
    { id: "contaBancaria", label: "Conta Bancária", field: "contaBancaria" },
    { id: "dtInicio", label: "Inicio", field: "dtInicio" },
    { id: "dtFim", label: "Fim", field: "dtFim" },
    {
      label: "Info",
      no_ordering: true,
      render: (id) => (
        <>
          <IconButton
            aria-label="edit"
            className={styles.iconeTabela}
            onClick={() => handleOpenTransacoesModal(id)}
          >
            <CurrencyExchange />
          </IconButton>
          <IconButton
            aria-label="edit"
            className={styles.iconeTabela}
            onClick={() => handleOpenConciliacoesModal(id)}
          >
            <TextSnippetIcon />
          </IconButton>
          <IconButton
            aria-label="edit"
            className={styles.iconeExclusao}
            onClick={() => handleOpenDeleteExtratoModal(id)}
          >
            <DeleteIcon />
          </IconButton>
        </>
      ),
    },
  ];

  const columnsTransacoes = [
    { id: "transacaoId", label: "ID da\nTransação", field: "transacaoId" },
    {
      id: "tipoTransacao",
      label: "Tipo da\nTransação",
      field: "tipoTransacao",
    },
    { id: "dtTransacao", label: "Data da\nTransação", field: "dtTransacao" },
    { id: "quantia", label: "Quantia", field: "quantia_cellVal" },
    {
      id: "checkNumber",
      label: "Número de\nVerificação",
      field: "checkNumber",
    },
    {
      id: "descricaoTransacao",
      label: "Descrição da Transação",
      field: "descricaoTransacao",
    },
  ];

  useEffect(() => {
    const st = location.state;
    if (!st?.idEmpresa) return;
    const empresaId = String(st.idEmpresa);
    setEmpresaInicial({
      idEmpresa: empresaId,
      cnpj: st.cnpj ? String(st.cnpj).replace(/\D/g, "") : null,
    });
    setIdEmpresa(empresaId);
    if (st.cnpj) {
      setCnpj(String(st.cnpj).replace(/\D/g, ""));
    }
  }, [location.state]);

  useEffect(() => {
    idEmpresa ? handleAtualizar() : setData([]);
  }, [idEmpresa]);

  const handleChangeBank = (event) => {
    setBankSelected(event.target.value);
  };

  const handleOrganizaDatas = (data) => formatarDataExibicaoBr(data);

  const handleListBanks = async () => {
    try {
      const bancosCliente = await buscarContasBancarias(idEmpresa);
      if (bancosCliente.contasBancarias.length > 0) {
        const bancosClienteSet = new Set(
          bancosCliente.contasBancarias.map((code) =>
            code.codigo_banco.padStart(3, "0")
          )
        );

        const listaFiltrada = bancos.filter((banco) =>
          bancosClienteSet.has(banco.code.toString().padStart(3, "0"))
        );

        setBanks(
          listaFiltrada.map((banco) => {
            return { value: banco.code, label: banco.name };
          })
        );
      } else {
        setBanks([{ value: "", label: "" }]);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleAtualizar = async () => {
    setLoading(true);
    try {
      const response = await buscarExtrato(idEmpresa);
      const extratos = response.extratos;
      const novoExtrato = extratos.map((item) => {
        return {
          ...item,
          dtInicio: handleOrganizaDatas(item.dtInicio),
          dtFim: handleOrganizaDatas(item.dtFim),
        };
      });
      setData(novoExtrato);
      await handleListBanks();
      setLoading(false);
    } catch (err) {
      if (err.response) {
        setMsg(
          err.response.data?.mensagem?.trim() || MSG_ERRO_PADRAO
        );
        handleOpenSnackbarErro();
      } else {
        setMsg(MSG_ERRO_PADRAO);
        handleOpenSnackbarErro();
      }
      setLoading(false);
    }
  };

  const handleCloseBankDialog = () => {
    setExtrato({});
    setOpenBankDialog(false);
  };

  const handleOpenBankDialog = (event) => {
    setExtrato(event);
    const file = event.target.files[0];

    if (file.type === "application/pdf") {
      setOpenBankDialog(true);
    } else {
      handleUpload(event);
    }
  };

  const handleOpenTransacoesModal = async (rowData) => {
    try {
      const response = await buscarTransacoes(
        idEmpresa,
        rowData.idConciliacaoExtrato
      );
      const transacoes = response.transacoes;
      const novaTransacoes = transacoes.map((item) => {
        return {
          ...item,
          dtTransacao: handleOrganizaDatas(item.dtTransacao),
          quantia_cellVal: formatToBRL(Number(item.quantia)),
        };
      });
      setDadosTransacoes(novaTransacoes);
    } catch (err) {
      if (err.response) {
        setMsg(
          err.response.data?.mensagem?.trim() || MSG_ERRO_PADRAO
        );
        handleOpenSnackbarErro();
      } else {
        setMsg(MSG_ERRO_PADRAO);
        handleOpenSnackbarErro();
      }
    }
    setOpenTransacaoModal(true);
  };

  const handleCloseTransacoesModal = () => {
    setOpenTransacaoModal(false);
  };

  const carregarConciliacoesPagina = async ({
    idExtrato: idExtratoParam,
    tipoContabil: tipoParam,
    pagina: paginaParam,
    tamanhoPagina: tamanhoParam,
    filtrosListagem: filtrosParam,
  } = {}) => {
    const extratoId = idExtratoParam ?? idExtrato;
    const tipo = tipoParam ?? tipoContabilConciliacao;
    const pagina =
      paginaParam !== undefined ? paginaParam : paginacaoConciliacoes.pagina;
    const tamanhoPagina =
      tamanhoParam !== undefined
        ? tamanhoParam
        : paginacaoConciliacoes.tamanhoPagina;
    const filtros =
      filtrosParam !== undefined ? filtrosParam : filtrosListagem;
    if (!idEmpresa || extratoId == null) return;
    setLoading(true);
    try {
      const params = montarParamsBuscarConciliacoes(filtros, {
        tipoContabil: tipo,
        pagina,
        tamanhoPagina,
      });
      const response = await buscarConciliacoes(idEmpresa, extratoId, params);
      const aplicado = aplicarRespostaConciliacoes(response, {
        formatarQuantia: (n) => formatToBRL(n),
      });
      setDadosConciliacoes(aplicado.conciliacoes);
      setCapaSaldoConciliacao(aplicado.capaSaldo);
      setPaginacaoConciliacoes(aplicado.paginacao);
    } catch (err) {
      if (err.response) {
        setMsg(
          err.response.data?.mensagem?.trim() || MSG_ERRO_PADRAO
        );
        handleOpenSnackbarErro();
      } else {
        setMsg(MSG_ERRO_PADRAO);
        handleOpenSnackbarErro();
      }
      throw err;
    } finally {
      setLoading(false);
    }
  };

  const handleOpenConciliacoesModal = async (rowData) => {
    const novoExtratoId = rowData.idConciliacaoExtrato;
    setFiltrosListagem(defaultFiltrosConciliacao);
    setFiltrosModal(defaultFiltrosConciliacao);
    setIdExtrato(novoExtratoId);
    setExtratoConciliacao(rowData);
    setCapaSaldoConciliacao(null);
    setTipoContabilConciliacao("dominio");
    try {
      await carregarConciliacoesPagina({
        idExtrato: novoExtratoId,
        tipoContabil: "dominio",
        pagina: 0,
        tamanhoPagina: paginacaoConciliacoes.tamanhoPagina,
        filtrosListagem: defaultFiltrosConciliacao,
      });
      setOpenConciliacaoModal(true);
    } catch {
      // mensagem já exibida em carregarConciliacoesPagina
    }
  };

  const handleCloseConciliacoesModal = () => {
    setOpenConciliacaoModal(false);
    setExtratoConciliacao(null);
    setCapaSaldoConciliacao(null);
    setLoadingAcaoConciliacao(null);
  };

  const handleOpenDeleteExtratoModal = async (rowData) => {
    setEditRowData(rowData);
    setOpenDeleteExtratoModal(true);
  };

  const handleCloseDeleteExtratoModal = () => {
    setOpenDeleteExtratoModal(false);
  };

  const handleOpenSnackbarSucesso = () => {
    setOpenSnackbarSucesso(true);
  };

  const handleCloseSnackbarSucesso = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnackbarSucesso(false);
  };

  const handleOpenSnackbarErro = () => {
    setOpenSnackbarErro(true);
  };

  const handleCloseSnackbarErro = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnackbarErro(false);
  };

  const handleCloseSnackbarAviso = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnackbarAviso(false);
  };

  const handleOpenFiltrarData = () => {
    const fl = filtrosListagem;
    setFiltrosModal({ ...fl });
    setIntervalo({
      intervalo: {
        ...(fl.dtInicio ? { dtInicio: fl.dtInicio } : {}),
        ...(fl.dtFim ? { dtFim: fl.dtFim } : {}),
      },
    });
    setQuantiaInputFocused(false);
    setOpenFiltrarDataModal(true);
  };

  const handleCloseFiltrarData = () => {
    const fl = filtrosListagem;
    setIntervalo({
      intervalo: {
        ...(fl.dtInicio ? { dtInicio: fl.dtInicio } : {}),
        ...(fl.dtFim ? { dtFim: fl.dtFim } : {}),
      },
    });
    setFiltrosModal({ ...fl });
    setQuantiaInputFocused(false);
    setOpenFiltrarDataModal(false);
  };

  const handleLimparFiltrosModal = async () => {
    if (conciliacaoOcupada) return;
    const limpos = { ...filtrosConciliacaoLimpos };
    setFiltrosModal(limpos);
    setFiltrosListagem(limpos);
    setIntervalo({ intervalo: {} });
    if (idEmpresa && idExtrato != null) {
      setLoadingAcaoConciliacao("filtrar");
      try {
        // Remove intervalo de exportação persistido (mesmo sem datas na grade).
        await filtrarConciliacoesPorData(
          idEmpresa,
          idExtrato,
          montarBodyIntervaloExportacao("", "")
        );
        await carregarConciliacoesPagina({
          idExtrato,
          tipoContabil: tipoContabilConciliacao,
          pagina: 0,
          tamanhoPagina: paginacaoConciliacoes.tamanhoPagina,
          filtrosListagem: limpos,
        });
      } catch (err) {
        if (err.response) {
          setMsg(
            err.response.data?.mensagem?.trim() || MSG_ERRO_PADRAO
          );
          handleOpenSnackbarErro();
        } else {
          setMsg(MSG_ERRO_PADRAO);
          handleOpenSnackbarErro();
        }
      } finally {
        setLoadingAcaoConciliacao(null);
      }
    }
  };

  const handleRestaurar = () => {
    if (conciliacaoOcupada) return;
    const empresaId = idEmpresa;
    const extratoId = idExtrato;
    if (!empresaId || extratoId == null) return;

    handleCloseConciliacoesModal();
    setMsg(
      "Restauração em andamento. As conciliações serão recalculadas em segundo plano."
    );
    handleOpenSnackbarSucesso();

    restaurarConciliacoes(empresaId, extratoId)
      .then(() => {
        setMsg("Restauração concluída com sucesso!");
        handleOpenSnackbarSucesso();
        void handleAtualizar();
      })
      .catch((err) => {
        if (err.response) {
          setMsg(
            err.response.data?.mensagem?.trim() || MSG_ERRO_PADRAO
          );
        } else {
          setMsg(MSG_ERRO_PADRAO);
        }
        handleOpenSnackbarErro();
      });
  };

  const handleFiltrarData = async () => {
    if (conciliacaoOcupada) return;
    setLoadingAcaoConciliacao("filtrar");
    const dtInicio = formatarDataIsoLocal(intervalo.intervalo?.dtInicio);
    const dtFim = formatarDataIsoLocal(intervalo.intervalo?.dtFim);
    if (deveBloquearPorIntervaloInvalido(dtInicio, dtFim)) {
      setMsg("A data de início não pode ser posterior à data fim.");
      handleOpenSnackbarErro();
      setLoadingAcaoConciliacao(null);
      return;
    }
    const nextFiltros = {
      ...filtrosModal,
      dtInicio,
      dtFim,
    };
    let avisoIntervalo = null;
    try {
      // Sempre sincroniza o intervalo de exportação: grava se houver datas, remove se vazio.
      try {
        await filtrarConciliacoesPorData(
          idEmpresa,
          idExtrato,
          montarBodyIntervaloExportacao(dtInicio, dtFim)
        );
      } catch (err) {
        const hasDatas = Boolean(dtInicio || dtFim);
        avisoIntervalo =
          err.response?.data?.mensagem?.trim() ||
          (hasDatas
            ? "Não foi possível salvar o intervalo de exportação."
            : "Não foi possível remover o intervalo de exportação.");
      }
      setFiltrosListagem(nextFiltros);
      await carregarConciliacoesPagina({
        idExtrato,
        tipoContabil: tipoContabilConciliacao,
        pagina: 0,
        tamanhoPagina: paginacaoConciliacoes.tamanhoPagina,
        filtrosListagem: nextFiltros,
      });
      setIntervalo({
        intervalo: {
          ...(dtInicio ? { dtInicio } : {}),
          ...(dtFim ? { dtFim } : {}),
        },
      });
      setFiltrosModal(nextFiltros);
      setQuantiaInputFocused(false);
      setOpenFiltrarDataModal(false);
      if (avisoIntervalo) {
        setMsgAviso(avisoIntervalo);
        setOpenSnackbarAviso(true);
      } else {
        setMsg("Filtrado com sucesso!");
        handleOpenSnackbarSucesso();
      }
    } catch (err) {
      if (err.response) {
        setMsg(
          err.response.data?.mensagem?.trim() || MSG_ERRO_PADRAO
        );
        handleOpenSnackbarErro();
      } else {
        setMsg(MSG_ERRO_PADRAO);
        handleOpenSnackbarErro();
      }
    } finally {
      setLoadingAcaoConciliacao(null);
    }
  };
  //  *
  const handleSaveConciliacoes = async () => {
    if (row) {
      const body = {
        conciliacao: row,
      };
      try {
        await atualizarConciliacoes(
          idEmpresa,
          row.idConciliacaoExtrato,
          row.idConciliacaoConciliacao,
          body
        );
        setRow(null);
      } catch (err) {
        if (err.response) {
          setMsg(
          err.response.data?.mensagem?.trim() || MSG_ERRO_PADRAO
        );
          handleOpenSnackbarErro();
        } else {
          setMsg(MSG_ERRO_PADRAO);
          handleOpenSnackbarErro();
        }
      }
    }
  };

  const handleValue = (id, name) => {
    const index = dadosConciliacoes.findIndex(
      (i) => i.idConciliacaoConciliacao === id
    );
    if (index === -1) return "";
    return dadosConciliacoes[index][name];
  };

  const handleChangeCheckbox = async (rowData, value) => {
    if (conciliacaoOcupada) return;
    if (rowData.ignorado !== value) {
      const index = dadosConciliacoes.findIndex(
        (i) => i.idConciliacaoConciliacao === rowData.idConciliacaoConciliacao
      );
      const list = [...dadosConciliacoes];
      const newRow = {
        ...rowData,
        ignorado: value,
      };
      list.splice(index, 1, newRow);
      setDadosConciliacoes(list);
      setCapaSaldoConciliacao((prev) =>
        ajustarCapaSaldoPorIgnorado(prev, rowData.quantia, value === true)
      );
      try {
        await atualizarConciliacoes(
          idEmpresa,
          rowData.idConciliacaoExtrato,
          rowData.idConciliacaoConciliacao,
          { conciliacao: { ignorado: value } }
        );
      } catch (err) {
        list.splice(index, 1, rowData);
        setDadosConciliacoes([...list]);
        setCapaSaldoConciliacao((prev) =>
          ajustarCapaSaldoPorIgnorado(prev, rowData.quantia, value !== true)
        );
        if (err.response) {
          setMsg(
          err.response.data?.mensagem?.trim() || MSG_ERRO_PADRAO
        );
          handleOpenSnackbarErro();
        } else {
          setMsg(MSG_ERRO_PADRAO);
          handleOpenSnackbarErro();
        }
      }
    }
  };

  const handleInputChanges = (rowData, event) => {
    if (rowData[event.name] !== event.value) {
      const index = dadosConciliacoes.findIndex(
        (i) => i.idConciliacaoConciliacao === rowData.idConciliacaoConciliacao
      );
      const list = [...dadosConciliacoes];
      const newRow = {
        ...rowData,
        [event.name]: event.value,
      };
      list.splice(index, 1, newRow);
      setRow(newRow);
      // handleSaveConciliacoes(newRow);
      setDadosConciliacoes(list);
    } else {
      setRow(null);
    }
  };

  const handleExportDominio = async () => {
    if (conciliacaoOcupada) return;
    if (!exportacaoSaldoLiberada(capaSaldoConciliacao)) return;
    setLoadingAcaoConciliacao("export-dominio");
    try {
      const response = await exportarConciliacoesDominio(idEmpresa, idExtrato);
      const responseSplit = response.split("****");
      const conteudo = responseSplit[1];
      const fileName = responseSplit[0];
      const element = document.createElement("a");
      const file = new Blob([conteudo], { type: "text/plain" });
      element.href = URL.createObjectURL(file);
      element.download = `${fileName}.txt`;
      document.body.appendChild(element);
      element.click();
    } catch (err) {
      if (err.response) {
        setMsg(
          err.response.data?.mensagem?.trim() || MSG_ERRO_PADRAO
        );
        handleOpenSnackbarErro();
      } else {
        setMsg(MSG_ERRO_PADRAO);
        handleOpenSnackbarErro();
      }
    } finally {
      setLoadingAcaoConciliacao(null);
    }
  };

  const handleExportProtheus = async () => {
    if (conciliacaoOcupada) return;
    if (!exportacaoSaldoLiberada(capaSaldoConciliacao)) return;
    setLoadingAcaoConciliacao("export-protheus");
    try {
      const response = await exportarConciliacoesProtheus(idEmpresa, idExtrato);
      const responseSplit = response.split("****");
      const conteudo = responseSplit[1];
      const fileName = responseSplit[0];
      const element = document.createElement("a");
      const file = new Blob([conteudo], { type: "text/plain" });
      element.href = URL.createObjectURL(file);
      element.download = `${fileName}.txt`;
      document.body.appendChild(element);
      element.click();
    } catch (err) {
      if (err.response) {
        setMsg(
          err.response.data?.mensagem?.trim() || MSG_ERRO_PADRAO
        );
        handleOpenSnackbarErro();
      } else {
        setMsg(MSG_ERRO_PADRAO);
        handleOpenSnackbarErro();
      }
    } finally {
      setLoadingAcaoConciliacao(null);
    }
  };

  const handleChangeDatas = (value, campo) => {
    const newDate = formatarDataIsoLocal(value);
    setIntervalo((prev) => {
      const nextIntervalo = { ...(prev.intervalo || {}) };
      if (newDate) {
        nextIntervalo[campo] = newDate;
      } else {
        delete nextIntervalo[campo];
      }
      return { ...prev, intervalo: nextIntervalo };
    });
  };

  const handleDebouncerChange = async (event) => {
    setLoading(true);
    try {
      const response = await buscarExtratoPorTexto(
        idEmpresa,
        event.target.value
      );
      const extratos = response.extratos;
      const novoExtrato = extratos.map((item) => {
        return {
          ...item,
          dtInicio: handleOrganizaDatas(item.dtInicio),
          dtFim: handleOrganizaDatas(item.dtFim),
        };
      });
      setData(novoExtrato);
      setLoading(false);
    } catch (err) {
      if (err.response?.status === 404) {
        setData([]);
      } else if (err.response) {
        setMsg(
          err.response.data?.mensagem?.trim() || MSG_ERRO_PADRAO
        );
        handleOpenSnackbarErro();
      } else {
        setMsg(MSG_ERRO_PADRAO);
        handleOpenSnackbarErro();
      }
    }
    setLoading(false);
  };

  const handleUpload = async (event) => {
    setLoading(true);
    const file = event.target.files[0];

    try {
      if (!file) {
        return;
      }
      if (!idEmpresa) {
        setMsg("Selecione uma empresa!");
        handleOpenSnackbarErro();
        return;
      }

      if (file.type === "application/pdf") {
        if (bankSelected === "") {
          setMsg("Selecione um banco!");
          handleOpenSnackbarErro();
          return;
        }
        handleCloseBankDialog();
      }

      const codigoBanco =
        file.type === "application/pdf"
          ? bankSelected.toString().slice(-3).padStart(3, "0")
          : undefined;

      await enfileirarImportacaoExtrato({
        idEmpresa,
        files: [file],
        codigoBanco,
        origemTela: "extrato_bancario",
      });

      setMsg("Arquivo enfileirado com sucesso. O processamento continuará em segundo plano.");
      handleOpenSnackbarSucesso();
      setTimeout(() => handleAtualizar(), 5000);
    } catch (err) {
      setMsg(resolverMensagemErroEnfileiramentoImportacao(err));
      handleOpenSnackbarErro();
    } finally {
      setBankSelected("");
      setLoading(false);
    }
    inputFileRef.current.value = null;
  };

  const handleGrupoECnpjChange = async (ids) => {
    const empresaId = idEmpresaFromComboIds(ids);
    if (!empresaId) {
      setIdEmpresa(undefined);
      setCnpj("");
      setEmpresaInicial(null);
      return;
    }
    const cnpj = ids.nome_CNPJ?.slice(0, ids.nome_CNPJ?.indexOf("-"));
    setCnpj(cnpj);
    setIdEmpresa(empresaId);
  };

  const handleDeleteExtrato = async () => {
    //Deleta
    await excluirExtrato(idEmpresa, editRowData.idConciliacaoExtrato)
      .then(async (response) => {
        setMsg(response.mensagem);
        // Buscar dados novamente para renderizar
        handleOpenSnackbarSucesso();
        handleAtualizar();
        handleCloseDeleteExtratoModal();
      })
      .catch((err) => {
        if (err.response) {
          setMsg(
          err.response.data?.mensagem?.trim() || MSG_ERRO_PADRAO
        );
          handleOpenSnackbarErro();
        } else {
          setMsg(MSG_ERRO_PADRAO);
          handleOpenSnackbarErro();
        }
      });
  };

  return (
    <div>
      <Main />

      <CRUDPageHeader
        headerIcon={<TextSnippetIcon fontSize="30px" />}
        headerTitle={"Extrato Bancário"}
        handleDebounceChange={handleDebouncerChange}
        AutoCompleteEmpresaCnpj
        handleEmpresaCnpjChange={handleGrupoECnpjChange}
        empresaInicial={empresaInicial}
        buttonUpload
        handleUpload={handleOpenBankDialog}
        refUpload={inputFileRef}
      />
      <TabelaDinamica
        data={data}
        columns={columns}
        loading={loading}
        disableEdit
        disableDelete
      />

      <Dialog open={openBankDialog} onClose={handleCloseBankDialog}>
        <DialogTitle>
          <div className={styles.iconSearch}>
            <AccountBalanceIcon sx={{ marginRight: ".5rem" }} /> Bancos
          </div>
        </DialogTitle>
        <DialogContent>
          Escolha um dos banco abaixo cadastrados para esta empresa:
          <div className={styles.selectContainerBanks}>
            <TextField
              id="standard-select"
              select
              label="Bancos"
              variant="standard"
              fullWidth
              onChange={handleChangeBank}
              value={bankSelected}
            >
              {banks.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </TextField>
          </div>
          <div className={styles.btnContainer}>
            <Button
              startIcon={<CloseIcon />}
              className={`${styles.btnModal} ${styles.cancelar}`}
              onClick={handleCloseBankDialog}
            >
              Cancelar
            </Button>
            <Button
              startIcon={<SendIcon />}
              className={`${styles.btnModal} ${styles.prosseguir}`}
              onClick={() => handleUpload(extrato)}
            >
              Importar
            </Button>
          </div>
        </DialogContent>
      </Dialog>
      {/* DIALOG DE TRANSAÇÕES */}
      <Dialog
        open={openTransacaoModal}
        onClose={handleCloseTransacoesModal}
        PaperProps={{
          style: {
            width: "calc(100vw - 8rem)", // Defina a largura desejada
          },
        }}
        maxWidth="xl" // Defina o tamanho máximo do modal
      >
        <DialogTitle>
          <div className={styles.tituloPopupContainer}>
            <CurrencyExchange fontSize="30px" sx={{ marginRight: "1rem" }} />
            <h1 className={styles.tituloPopup}>Transações</h1>
          </div>
        </DialogTitle>
        <TabelaDinamica
          data={dadosTransacoes}
          columns={columnsTransacoes}
          disableEdit
          disableDelete
        />
        <DialogActions className={styles.botoesPopupGeral}>
          <Button
            className={styles.botaoPopupCancelar}
            onClick={handleCloseTransacoesModal}
            size="small"
          >
            Fechar
          </Button>
        </DialogActions>
      </Dialog>

      {/* DIALOG DE CONCILIAÇÕES */}
      <Dialog
        sx={{
          "& .css-1fu2e3p-MuiPaper-root-MuiDialog-paper": {
            maxWidth: "100vw",
          },
        }}
        open={openConciliacaoModal}
        onClose={handleCloseConciliacoesModal}
        PaperProps={{
          style: {
            width: "100vw",
            height: "100vh",
            maxWidth: "100vw",
            maxHeight: "100vh",
            position: "relative",
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
          },
        }}
        maxWidth="lg"
      >
        {renderModalLoader(
          conciliacaoOcupada && openConciliacaoModal
        )}
        <DialogTitle>
          <div className={styles.tituloPopupContainerConciliacao}>
            <div className={styles.nomeTituloPopupContainerConciliacao}>
              <TextSnippetIcon sx={{ marginRight: "1rem", fontSize: "32px" }} />
              <h1 className={styles.tituloPopup}>Conciliações</h1>
            </div>
            <div>
              <FormControlLabel
                disabled={conciliacaoOcupada}
                control={
                  <ProtheusDominioStyledSwitch
                    checked={tipoContabilConciliacao === "dominio"}
                    disabled={conciliacaoOcupada}
                    onChange={(event) => {
                      if (conciliacaoOcupada) return;
                      const novo = event.target.checked ? "dominio" : "protheus";
                      setTipoContabilConciliacao(novo);
                      carregarConciliacoesPagina({
                        tipoContabil: novo,
                        pagina: 0,
                        tamanhoPagina: paginacaoConciliacoes.tamanhoPagina,
                      });
                    }}
                  />
                }
                label={
                  tipoContabilConciliacao === "protheus" ? "Protheus" : "Domínio"
                }
              />
              <Button
                className={styles.botoesConciliacao}
                onClick={handleRestaurar}
                variant="contained"
                disabled={conciliacaoOcupada}
              >
                Restaurar Valores
              </Button>
              <Button
                className={styles.botoesConciliacao}
                onClick={handleOpenFiltrarData}
                variant="contained"
                disabled={conciliacaoOcupada}
              >
                Filtrar
              </Button>
            </div>
          </div>
        </DialogTitle>
        <DialogContent className={styles.dialogConciliacaoContent}>
          <TabelaConciliacaoExtrato
            data={dadosConciliacoes}
            acoesDesabilitadas={conciliacaoOcupada}
            handleChangeCheckbox={handleChangeCheckbox}
            handleInputChanges={handleInputChanges}
            handleSaveConciliacoes={handleSaveConciliacoes}
            handleValue={handleValue}
          />
        </DialogContent>
        <RodapeConciliacaoExtrato
          extrato={extratoConciliacao}
          capaSaldo={capaSaldoConciliacao}
          pagina={paginacaoConciliacoes.pagina}
          tamanhoPagina={paginacaoConciliacoes.tamanhoPagina}
          totalItens={paginacaoConciliacoes.totalItens}
          desabilitado={conciliacaoOcupada}
          tipoContabil={tipoContabilConciliacao}
          onPaginaChange={(event, newPage) => {
            if (conciliacaoOcupada) return;
            carregarConciliacoesPagina({ pagina: newPage });
          }}
          onTamanhoPaginaChange={(event) => {
            if (conciliacaoOcupada) return;
            const next = parseInt(event.target.value, 10);
            carregarConciliacoesPagina({
              pagina: 0,
              tamanhoPagina: next,
            });
          }}
          onExportarDominio={handleExportDominio}
          onExportarProtheus={handleExportProtheus}
          onFechar={handleCloseConciliacoesModal}
        />
      </Dialog>

      {/* DIALOG DE FILTRAR */}

      <Dialog
        open={openFiltrarDataModal}
        onClose={(_event, reason) => {
          if (reason === "backdropClick") return;
          handleCloseFiltrarData();
        }}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: { minHeight: "auto", maxWidth: 640, position: "relative", overflow: "visible" },
        }}
      >
        {renderModalLoader(
          conciliacaoOcupada && openFiltrarDataModal
        )}
        <DialogTitle sx={{ pb: 1, pt: 1.5 }}>
          <div className={styles.tituloPopupContainer}>
            <CalendarMonthIcon fontSize="30px" sx={{ marginRight: "1rem" }} />
            <h1 className={styles.tituloPopup}>Filtrar</h1>
          </div>
        </DialogTitle>
        <DialogContent sx={{ pt: 1.5, px: 2.5, pb: 0, overflow: "visible" }}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 1.5,
            }}
          >
            {/* Linha 1: datas */}
            <Box
              sx={{
                display: "flex",
                flexDirection: { xs: "column", sm: "row" },
                gap: 2,
                alignItems: { sm: "flex-start" },
                overflow: "visible",
              }}
            >
              <Box sx={{ flex: 1, minWidth: 0, overflow: "visible" }}>
                <GenericDatePicker
                  label={"Data de Início"}
                  placeholder={"Data Início"}
                  value={intervalo.intervalo?.dtInicio || null}
                  onChange={(e) => handleChangeDatas(e, "dtInicio")}
                />
              </Box>
              <Box sx={{ flex: 1, minWidth: 0, overflow: "visible" }}>
                <GenericDatePicker
                  label={"Data Fim"}
                  placeholder={"Data Fim"}
                  value={intervalo.intervalo?.dtFim || null}
                  onChange={(e) => handleChangeDatas(e, "dtFim")}
                />
              </Box>
            </Box>
            <Typography variant="caption" color="text.secondary" sx={{ mt: -0.5 }}>
              O intervalo de datas filtra a grade e também define o recorte da
              exportação Domínio/Protheus. Limpar filtros remove esse recorte.
            </Typography>
            {/* Linha 2: metade descrição, metade quantia */}
            <Box
              sx={{
                display: "flex",
                flexDirection: { xs: "column", sm: "row" },
                gap: 2,
                alignItems: { sm: "stretch" },
                width: "100%",
              }}
            >
              <Box sx={{ flex: "1 1 0", minWidth: 0 }}>
                <TextField
                  fullWidth
                  size="small"
                  label="Descrição da transação"
                  placeholder="Ex.: TED"
                  helperText="Busca parcial no texto do extrato (ex.: TED, PIX)."
                  value={filtrosModal.descricao}
                  onChange={(e) =>
                    setFiltrosModal((prev) => ({
                      ...prev,
                      descricao: e.target.value,
                    }))
                  }
                />
              </Box>
              <Box sx={{ flex: "1 1 0", minWidth: 0 }}>
                <TextField
                  fullWidth
                  size="small"
                  label="Quantia"
                  value={filtrosModal.quantiaBusca}
                  onChange={(e) =>
                    setFiltrosModal((prev) => ({
                      ...prev,
                      quantiaBusca: applyQuantiaBuscaMask(e.target.value),
                    }))
                  }
                  onFocus={() => setQuantiaInputFocused(true)}
                  onBlur={() => setQuantiaInputFocused(false)}
                  placeholder={
                    quantiaInputFocused ? "Ex.: 1.234,56" : ""
                  }
                  inputProps={{ inputMode: "numeric" }}
                />
              </Box>
            </Box>
            {/* Linha 3: débito */}
            <Box
              sx={{
                display: "flex",
                flexDirection: { xs: "column", sm: "row" },
                gap: 2,
              }}
            >
              <TextField
                sx={{ flex: 1, minWidth: 0 }}
                size="small"
                label="Conta do débito"
                placeholder="Ex.: 1.1.02"
                value={filtrosModal.contaDebito}
                onChange={(e) =>
                  setFiltrosModal((prev) => ({
                    ...prev,
                    contaDebito: e.target.value,
                  }))
                }
              />
              <TextField
                sx={{ flex: 1, minWidth: 0 }}
                size="small"
                label="Descrição da conta do débito"
                placeholder="Ex.: fornecedor"
                helperText='Busca na descrição contábil; o lado bancário costuma aparecer como "Banco".'
                value={filtrosModal.descricaoDebito}
                onChange={(e) =>
                  setFiltrosModal((prev) => ({
                    ...prev,
                    descricaoDebito: e.target.value,
                  }))
                }
              />
            </Box>
            {/* Linha 4: crédito */}
            <Box
              sx={{
                display: "flex",
                flexDirection: { xs: "column", sm: "row" },
                gap: 2,
              }}
            >
              <TextField
                sx={{ flex: 1, minWidth: 0 }}
                size="small"
                label="Conta do crédito"
                placeholder="Ex.: 2.1.01"
                value={filtrosModal.contaCredito}
                onChange={(e) =>
                  setFiltrosModal((prev) => ({
                    ...prev,
                    contaCredito: e.target.value,
                  }))
                }
              />
              <TextField
                sx={{ flex: 1, minWidth: 0 }}
                size="small"
                label="Descrição da conta do crédito"
                placeholder="Ex.: cliente"
                helperText='Busca na descrição contábil; o lado bancário costuma aparecer como "Banco".'
                value={filtrosModal.descricaoCredito}
                onChange={(e) =>
                  setFiltrosModal((prev) => ({
                    ...prev,
                    descricaoCredito: e.target.value,
                  }))
                }
              />
            </Box>
            {/* Ignorar: centralizado na metade esquerda da linha */}
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                width: "100%",
                pt: 0.5,
              }}
            >
              <Box
                sx={{
                  flex: "1 1 0",
                  minWidth: 0,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  gap: 0.5,
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: 1,
                  }}
                >
                <Typography variant="body2" color="text.secondary" component="span">
                  Ignorar
                </Typography>
                <Typography variant="body2" component="span">
                  Não
                </Typography>
                <Switch
                  size="small"
                  checked={filtrosModal.filtroIgnorado === "sim"}
                  onChange={(e) =>
                    setFiltrosModal((prev) => ({
                      ...prev,
                      filtroIgnorado: e.target.checked ? "sim" : "nao",
                    }))
                  }
                  color="primary"
                />
                <Typography variant="body2" component="span">
                  Sim
                </Typography>
                </Box>
                <Typography variant="caption" color="text.secondary" align="center">
                  Desligado = exibe só lançamentos não ignorados (padrão ao abrir).
                </Typography>
              </Box>
              <Box sx={{ flex: "1 1 0", minWidth: 0 }} aria-hidden />
            </Box>
          </Box>
        </DialogContent>
        <DialogActions
          sx={{
            justifyContent: "space-between",
            flexWrap: "wrap",
            gap: 1,
            px: 2.5,
            pt: 0.5,
            pb: 1.5,
          }}
        >
          <Button
            className={styles.botaoPopupCancelar}
            variant="outlined"
            onClick={handleLimparFiltrosModal}
            disabled={conciliacaoOcupada}
          >
            Limpar filtros
          </Button>
          <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
            <Button
              className={styles.botaoPopupSalvar}
              variant="contained"
              onClick={handleFiltrarData}
              disabled={conciliacaoOcupada}
            >
              Filtrar
            </Button>
            <Button
              className={styles.botaoPopupCancelar}
              onClick={handleCloseFiltrarData}
            >
              Fechar
            </Button>
          </Box>
        </DialogActions>
      </Dialog>

      {/* Dialog de exclusão */}
      <Dialog
        open={openDeleteExtratoModal}
        onClose={handleCloseDeleteExtratoModal}
        PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title"
      >
        <DialogTitle
          className={styles.tituloExclusao}
          style={{ cursor: "move" }}
          id="draggable-dialog-title"
        >
          Atenção!
        </DialogTitle>
        <DialogContent>
          <DialogContentText className={styles.textoExclusao}>
            Você realmente deseja excluir permanentemente o extrato{" "}
            {editRowData.idConciliacaoExtrato}?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            className={styles.botaoPopupCancelarExclusao}
            autoFocus
            onClick={handleCloseDeleteExtratoModal}
          >
            Cancelar
          </Button>
          <Button
            className={styles.botaoPopupExcluir}
            onClick={handleDeleteExtrato}
          >
            Sim
          </Button>
        </DialogActions>
      </Dialog>

      <MensagemSucesso
        open={openSnackbarSucesso}
        handleClose={handleCloseSnackbarSucesso}
        msg={msg}
      />

      <MensagemErro
        open={openSnackbarErro}
        handleClose={handleCloseSnackbarErro}
        msg={msg}
      />

      <MensagemAviso
        open={openSnackbarAviso}
        handleClose={handleCloseSnackbarAviso}
        msg={msgAviso}
      />
    </div>
  );
};
export default Extrato;
